import React from 'react';

import PropTypes from 'prop-types';

import NewDataIcon from 'src/Components/Common/Svg/NewDataIcon';

import NewUploadSpeedIcon from 'src/Components/Common/Svg/NewUploadSpeedIcon';

import NewDownloadSpeedIcon from 'src/Components/Common/Svg/NewDownloadSpeedIcon';

import ChevronRightIcon from 'src/Components/Common/Svg/ChevronRightIcon';

import './Plan.css';

const Plan = ({ planDetails, inclusions }) => {

  const { download, upload } = planDetails;

  const onBackButton = () => {

    window.location.href = '/cloud/fibre/sales/choosePlan';
  };

  return (
    <div className="plan-container">

      <div className="plan-header-container">

        <span className="plan-header">
          Uncapped fibre
        </span>

        <div onClick={ onBackButton }>

          <span className="plan-sub-header">
            Change plan
          </span>

          <ChevronRightIcon />

        </div>
      </div>

      <div className="plan-main-container">

        {/* <div className="plan-logo-container">

          <span className='plan-logo-heading'>Infrastructure provider: </span>

          <div className="plan-provider-img-container">

            <img
              className="plan-provider-img"
              src={ packageProvider }
              alt="Package Provider"
            />
          </div>
        </div> */}

        <div className="plan-sub-container">

          <span className='plan-logo-heading'>Plan:</span>

          <span className="plan-items">
            <NewDataIcon /> &nbsp; Uncapped
            <span className='plan-items-text'>data</span>
          </span>

          <span className='plan-items'>
            <NewDownloadSpeedIcon /> &nbsp; { download }
            <span className='plan-items-text'>download speed</span>
          </span>

          <span className='plan-items'>
            <NewUploadSpeedIcon /> &nbsp; { upload }
            <span className='plan-items-text'>upload speed</span>
          </span>

        </div>
        {inclusions && inclusions?.length > 0 &&

          <div className="new-plan-details-contract-summary-deal">
            <span className='new-plan-details-contract-summary-deal-inclusions-text'>Also included:</span>

            {inclusions?.map((item, index) => (
              <div key={index} className="new-plan-details-contract-summary-deal-description">
                <span className='new-plan-details-contract-summary-deal-cap'>{item}</span>
              </div>
            ))
            }
          </div>
        }
      </div>
    </div>
  );
};

Plan.propTypes = {
  planDetails: PropTypes.shape({
    download: PropTypes.string.isRequired,
    upload: PropTypes.string.isRequired
  }).isRequired
  // packageProvider: PropTypes.string.isRequired
};

export default Plan;
